import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { FormattedDate } from 'components/intl'
import { compose } from 'recompose'
import { get } from 'lodash'

import { AwardChange, AwardTypeChange, AwardChangeMode } from 'containers/forms/awards'
import { Modal, FileDownload } from 'containers/misc'
import { Title, Section } from 'components/layout'
import { Module, FormData, ButtonDropdown, Button } from 'components/misc'

import { modal } from 'redux/modules/app'
import { ROLES, PROGRESS_STATES, ORGANIZATION_MODES } from 'constants/enums'
import { getActiveRole } from 'utils/token'
import { filterByRole } from 'redux/selectors/misc'

import styles from './award-overview.styl'

const enhance = compose(
  connect(
    ({ auth }) => ({
      activeOrganization: auth.organization
    }),
    { modal }
  )
)

class AwardSettings extends Component {
  static propTypes = {
    modal: PropTypes.func.isRequired,
    currentAwardLevel: PropTypes.object.isRequired,
    onGenerateAwardReport: PropTypes.func.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    isReportLoading: PropTypes.bool,
    awardOfficeSignoffDate: PropTypes.string,
    awardCeremonyDate: PropTypes.string,
    awardLeaderSignoffDate: PropTypes.string,
    awardId: PropTypes.number,
    awardType: PropTypes.object.isRequired,
    awardState: PropTypes.object,
    awardMode: PropTypes.object.isRequired,
    organizationMode: PropTypes.object.isRequired
  }

  state = {
    sent: false
  }

  handleGenerateReport = type => {
    const { awardId } = this.props

    this.props.onGenerateAwardReport(awardId, type).then(() => {
      this.setState({
        sent: true
      })
    })
  }

  handleCancel = () => {
    this.props.modal(null)
    this.setState({
      sent: false
    })
  }

  render() {
    const {
      awardId,
      isReportLoading,
      activeOrganization,
      awardType,
      awardState,
      awardMode,
      organizationMode,
      currentAwardLevel,
      awardOfficeSignoffDate,
      awardLeaderSignoffDate,
      awardCeremonyDate
    } = this.props
    const { sent } = this.state
    const role = getActiveRole(activeOrganization)
    const isAwardInactive =
      awardState.value === PROGRESS_STATES.awardInactive.id

    const displayAwardLeaderSignoffDate =
      awardState.value === PROGRESS_STATES.awardOfficeSignoff.id ||
      awardState.value === PROGRESS_STATES.awardCeremony.id ||
      awardState.value === PROGRESS_STATES.awardAwardComplete.id ||
      isAwardInactive
    const displayAwardSignoffDate =
      awardState.value === PROGRESS_STATES.awardCeremony.id ||
      awardState.value === PROGRESS_STATES.awardAwardComplete.id ||
      isAwardInactive
    const displayCeremonyDate =
      awardState.value === PROGRESS_STATES.awardAwardComplete.id ||
      isAwardInactive

    const isOrganizationOffline =
      get(organizationMode, 'value') !== ORGANIZATION_MODES.online.id

    const canChangeAwardMode =
      get(organizationMode, 'value') === ORGANIZATION_MODES.hybrid.id

    const actions = [
      {
        id: 1,
        label: 'Change award level',
        intlKey: 'award.change_award_level',
        onClick: () => this.props.modal('modal-change-award-level'),
        roles: [
          ROLES.NAO_STAFF.u,
          ROLES.OA.u,
          ROLES.SOA.u,
          ROLES.IF_STAFF_SUPER.u,
          ROLES.IF_REGION.u,
          ROLES.GBT.u
        ]
      },
      {
        id: 2,
        label: "Change Awards's mode",
        intlKey: 'organisation.change_award_mode',
        onClick: () => this.props.modal('organization-change-mode'),
        iacOnly: false,
        oaOnly: false,
        hide: !canChangeAwardMode,
        roles: [
          ROLES.IF_STAFF_SUPER.u,
          ROLES.GBT.u,
          ROLES.NAO_STAFF.u,
          ROLES.IF_REGION.u,
          ROLES.OA.u,
          ROLES.SOA.u
        ]
      },
      {
        id: 3,
        label: "Change Award type",
        intlKey: 'award.change_award_type',
        onClick: () => this.props.modal('modal-change-award-type'),
        roles: [
          ROLES.IF_STAFF_SUPER.u,
          ROLES.GBT.u,
          ROLES.NAO_STAFF.u,
          ROLES.IF_REGION.u,
          ROLES.OA.u,
          ROLES.SOA.u
        ]
      },
      {
        id: 4,
        label: 'Generate report',
        intlKey: 'award.generate_award_report',
        onClick: () => this.props.modal('modal-generate-award-report'),
        roles: [ROLES.ALL.u]
      }
    ]

    const actionsByRole = filterByRole(actions, role)

    return (
      <Module title="Overview" intlKey="moduleTitle.overview" primary grid>
        <div className="row">
          <div className="col-xs-4">
            <FormData label="State" intlKey="label.award_state">
              {awardState.translationText || '---'}
            </FormData>
          </div>
          {isOrganizationOffline &&
            <div className="col-xs-4">
              <FormData label="Award mode" intlKey="label.award_mode">
                {awardMode.translationText || '---'}
              </FormData>
            </div>}
            <div className="col-xs-4">
              <FormData label="Award type" intlKey="label.award_type">
                {awardType.translationText || '---'}
              </FormData>
            </div>
          {displayAwardLeaderSignoffDate &&
            awardLeaderSignoffDate &&
            <div className="col-xs-4">
              <FormData
                label="Award Leader Sign-off date"
                intlKey="label.award_leader_signoff_date"
                muted={isAwardInactive}
              >
                <FormattedDate value={awardLeaderSignoffDate} />
              </FormData>
            </div>}
          {displayAwardSignoffDate &&
            awardOfficeSignoffDate &&
            <div className="col-xs-4">
              <FormData
                label="Award Office Sign-off date"
                intlKey="label.award_office_signoff_date"
                muted={isAwardInactive}
              >
                <FormattedDate value={awardOfficeSignoffDate} />
              </FormData>
            </div>}
          {displayCeremonyDate &&
            awardCeremonyDate &&
            <div className="col-xs-4">
              <FormData
                label="Award Office Sign-off date"
                intlKey="label.award_office_signoff_date"
                muted={isAwardInactive}
              >
                <FormattedDate value={awardCeremonyDate} />
              </FormData>
            </div>}
        </div>

        <div className={styles.dropdown}>
          {' '}
          <ButtonDropdown
            icon="settings"
            secondary
            actions={actionsByRole}
            intlKey="button.award_settings"
            right
          >
            Account Settings
          </ButtonDropdown>
        </div>
        <Modal id="modal-change-award-level" enableOverflow customActions>
          <AwardChange
            awardId={awardId}
            onClose={this.handleCancel}
            currentAwardLevel={currentAwardLevel}
          />
        </Modal>
        <Modal id="modal-change-award-type" enableOverflow customActions>
          <AwardTypeChange
            awardId={awardId}
            onClose={this.handleCancel}
          />
        </Modal>
        <Modal
          id="modal-generate-award-report"
          enableOverflow
          customActions
          showCloseBtn={sent}
          onClose={this.handleCancel}
        >
          <Section loading={isReportLoading} inModal>
            <FileDownload id={awardId} />

            {!sent &&
              <div>
                <Title
                  h2
                  className="text--center"
                  intlKey="moduleTitle.please_confirm"
                >
                  Please confirm
                </Title>

                <div className="row">

                  <div className="col-xs-12 text--center">
                    <Button
                      onClick={() => this.handleGenerateReport(1)}
                      intlKey="button.generate_summary_report"
                    >
                      Generate Award Summary Report
                    </Button>

                    <Button
                        style={{ marginLeft: '20px'}}
                        onClick={() => this.handleGenerateReport(2)}
                        intlKey="button.generate_award_detail_report"
                    >
                      Generate Award Detail Report
                    </Button>

                  </div>
                  <div style={{ marginTop: '10px'}} className="col-xs-12 text--center">
                    <Button
                        intlKey="button.close"
                        secondary
                        onClick={this.handleCancel}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </div>}
          </Section>
        </Modal>
        <Modal id="organization-change-mode" compact customActions>
          <AwardChangeMode
            awardId={awardId}
            awardMode={awardMode}
            currentAwardLevel={currentAwardLevel}
          />
        </Modal>
      </Module>
    )
  }
}

export default enhance(AwardSettings)
